import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

const containerApp = <React.StrictMode><App /></React.StrictMode>;
const containerRoot = document.getElementById('root');

ReactDOM.render(containerApp, containerRoot);